<template>
  <div class="Appguobaodetail-page">
      <div class="Appguobaodetail">
        <div class="agd_video">
            <div v-if="titleShow">
                <div class="ecla_left" >
                    <div class="ecla-back" @click="back()">
                        <img src="https://www.koalaknow.com/img/icon/icon-back-gray.png" alt="">
                        <span class="i18n" data-properties="backText" data-ptype="text">返回</span>
                    </div>
                    <span class="title">{{title}}</span>
                </div>
                <div class="header-box">
                    <div class="mobile-header">
                        <div @click="back()" class="mobile-back"></div>
                        <h2>{{title}}</h2>
                    </div>
                    <div class="mobile-header-padd"></div>
                </div>
            </div>
            <div id="container" class="video-wrapper"></div>
        </div>
        <div class="adg_artile" v-html="detail_info.ntContent"></div>
    </div>
  </div>
</template>
<script>
import http from "../../../service/http";
import "../../../service/txplayer";
export default {
  name: "Appguobaodetail",
  data() {
    return {
      id: "",
      detail_info: [],
      title:'',
      titleShow:false
    };
  },
  mounted() {
      this.titleShow=http.getQueryString('titleShow')
    this.id = http.getQueryString("id");
    this.getDetail(this.id);
  },
  methods: {
    playerInit(vid) {
      var player = new Txplayer({
        containerId: "container",
        vid: vid,
        width: "100%",
        height: screen.availHeight / 3,
        autoplay: true,
      });
      player.on("ready", () => {
        setTimeout(()=>{
            var heigh = $(".agd_video").height()+20;
            $('.adg_artile').css({'padding-top':heigh+'px'})
        },300)
      });
    },
    getDetail(id) {
      var that = this;
      var data = {
        cmd: "GetNationalTreasureById",
        ntid: id,
      };
      http.req(
        data,
        function (res) {
          that.detail_info = res.info;
          document.title = res.info.ntTitle;
        that.title=res.info.ntTitle
          var videoUrl = res.info.ntVideoUrl;
          that.playerInit(videoUrl);
        },
        "https://apinew.koalaknow.com/api/AlumniAssociationRequestHandle/InterfaceV1"
      );
    },
    back(){
        window.history.go(-1);
    }
  },
};
</script>
<style scoped>
.Appguobaodetail-page{
    background-color: #F5F5F5;
    padding: 30px 0;
}
.Appguobaodetail{
    max-width: 1320px;
    margin: 0 auto;
    background-color: #fff;
}

.Appguobaodetail{
  padding: 0 0 100px 0;
  box-sizing: border-box;
}
.adg_artile >>> section img {
  display: none !important;
}

.agd_video {
  width: 100vw;
  position: fixed;
  top: 0;
  z-index: 2;
  background-color: #fff;
}

#container {
  /* height: 480px; */
}
.adg_artile {
  /* margin: 500px 0 0 0; */
}
/* 手机端标题 */

.mobile-header-padd{
    display: block;
    height: 80px;
}
.mobile-header{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
    min-height: 80px;
    background-color: #fff;
    z-index: 90;
    display: flex;
    justify-content: center;
    align-items: center;
}
.mobile-header h2{
    width: 73vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    /* line-height: 24px; */
    color: #333333;
    /* padding: 18px 0; */
    text-align: center;
     display: -webkit-box !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}
.mobile-back{
    width:64px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: url('https://www.koalaknow.com/img/personalcenter/exchangeMobile/icon-mobile-back.png?202107330') no-repeat center center;
    background-size: 16px;
}
.mobile-header-right{
    position: absolute;
    right: 36px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 40px;
    color: #666666;
    padding: 10px 0;
    display: none;
}
.ecla_left{
    display: none;
}
@media screen and (min-width: 750px){
    .mobile-header,.mobile-header-padd{
        display: none;
    }
    .Appguobaodetail{
        height: calc(100vh - 60px);
        box-shadow: 0px 1px 4px rgb(0 0 0 / 6%);
        overflow: auto;
        border-radius: 10px;
    }
    .agd_video{
        width: 1320px;
        left: 50%;
        top: 30px;
        transform: translateX(-50%);
        border-radius: 10px;
    }
    .ecla_left{
        line-height: 70px;
        border-bottom: 1px solid #EEEEEE;
        position: relative;
        text-align: center;
        display: block;
    }
    .ecla_left .title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
    }
    .ecla-back{
        position: relative;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #999999;
        padding: 10px;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        box-sizing: border-box;
        cursor: pointer;
    }
    .ecla-back img{
        width: 6px;
        height: 11px;
        margin-right: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/App/App_guobao_detail.vue